@let message = messageSg();

@if (message) {
  <div class="atn-admin-error-message">
    {{ message }}
  </div>
}
